/* eslint-disable import/prefer-default-export */
import { sessionStates } from '@constants/index';
import {
  getLatestSession,
  getQuizState,
  getSpecialInfoString,
  slides
} from '@models/Item';
import { addTime, compareDates } from '@utils/dates';

export const processLessonData = (lesson) => {
  const data = {
    ...lesson,
    ...(lesson.properties || {}),
    type: lesson.type ?? 'post',
    contentRank: lesson.contentTypeItemRank
  };
  if (data.type === 'live_class' || data.type === 'LiveClass') {
    data.type = 'post';
  }
  if (data.type === 'Test' || data.type === 'Quiz') {
    data.type = 'quiz';
  }
  const item = { ...data };
  data.displayLanguage = item.languageDisplay;
  data.name = item.name || item.title;
  data.description = item.description || null;
  data.slug = item.slug || item?.programme?.slug || '-';
  data.thumbnail = item.thumbnailV1 || item.thumbnail || item.video?.thumbnail;
  data.thumbnailV1 = item.thumbnailV1 || data.thumbnail;
  data.isSpecial = item.isSpecial || item.programme?.isSpecial;
  data.liveAt = item.liveAt ? new Date(item.liveAt) : new Date(item.startTime);
  data.liveAtString = item.liveAt || item.startTime;
  data.liveAtTime = new Date(item.liveAt || item.startTime).getTime();
  data.startedAt = item.startedAt ? new Date(item.startedAt) : null;
  data.author = item.author || null;
  data.startsAt = item.startTime || item.startsAt || null;
  data.programmeUid =
    item.programmeUid || item.programme?.uid || item.collection?.uid;
  if (item.programme || item.collection) {
    data.programme = item.programme
      ? { course: item.programme }
      : { course: item.collection };
  }
  data.goalUid = item.goalUid || item.programme?.goal?.uid || null;
  data.goalName = item.goalName || item.programme?.goal?.name || null;
  if (!data.contentRank)
    data.contentRank = item.contentTypeItemRank || item.rank;

  data.hasWatched = item.hasWatched || item.watched || item.hasAttempted;
  data.liveClassUrl = item.liveClassUrl;
  data.videoUrl = item.videoUrl || item.video?.url;
  data.duration = item.duration;
  data.lessonDuration =
    item.videoDuration || item.video?.duration || item.duration;
  data.endsAt = addTime(data.liveAt, data.lessonDuration, 's');
  data.finishedAt = item.finishedAt ? new Date(item.finishedAt) : data.endsAt;
  data.videoType = item.video?.type;
  data.youtubeId = item.video?.youtubeId;
  data.key = item.distributionKey ? item.distributionKey : item.key || null;
  data.isLive =
    item.isLive || data.type === 'post'
      ? item.state === sessionStates.LIVE
      : data.secondsBeforeLive === 0 &&
        compareDates(new Date(), data.startsAt) === 0;
  if (data.type === 'quiz')
    data.isLive = getQuizState(data) === sessionStates.LIVE;
  data.slides = item.slidesPdf ? slides(item.slidesPdf) : null;
  data.latestSession = item.latestSession
    ? getLatestSession(item.latestSession)
    : null;
  data.totalQuestions = item.numQuestions;
  data.upvotes = item.recommendCount;
  data.goal = { topology: item.programme?.goal, uid: data.goalUid };
  data.specialInfoString =
    data.type === 'post' || data.classType === 1
      ? getSpecialInfoString(data)
      : '';
  data.isBookmarked = item.isBookmarked || item.bookmarked || false;
  data.programmeNM = item.collection2;
  data.liveClassDetails = item.value?.liveClass || item?.liveClass2;
  data.topology = item.topology ? { topology: item.topology } : null;
  data.practiceDpp = lesson?.practiceDpp || lesson?.value?.practiceDpp;
  return data;
};
